// This number is supplied by the business and is used by every WhatsApp CTA.
// Lives here (not inside
// WhatsAppWidget.tsx) so every consumer — the floating widget, ZP-56's
// supplier fallback CTA, ZP-59's tappable contact number — reads the same
// single source instead of each hardcoding its own copy.
export const WHATSAPP_NUMBER = "916366987212"; // +91 63669 87212, wa.me format (no spaces/plus)
// Staff can publish a different number (Admin → App settings); useContactInfo() sets it, and every link built by getWhatsAppLink uses it.
let published: string | null = null;
export const setWhatsAppNumber = (digits: string | null) => { published = digits; };

export function getWhatsAppLink(message: string): string {
  return `https://wa.me/${published ?? WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

// Maps a route to a context-aware pre-filled WhatsApp greeting (ZP-88 AC3:
// "Become a Supplier" → a supplier-specific message, etc.). Longest-prefix
// match against location.pathname, falling back to a generic greeting.
const CONTEXT_MESSAGES: { prefix: string; message: string }[] = [
  {
    prefix: "/partnerships",
    message: "Hi, I'm interested in becoming a ZenFresh partner.",
  },
  {
    prefix: "/menu",
    message: "Hi, I have a question about an order from the ZenFresh menu.",
  },
  {
    prefix: "/locations",
    message: "Hi, I'd like to check if ZenFresh delivers to my area.",
  },
  {
    prefix: "/products",
    message: "Hi, I have a question about ZenFresh's products.",
  },
  {
    prefix: "/compliance",
    message:
      "Hi, I have a question about ZenFresh's compliance or food safety standards.",
  },
  {
    prefix: "/sustainability",
    message: "Hi, I have a question about ZenFresh's sustainability practices.",
  },
];

const DEFAULT_MESSAGE = "Hi, I'd like to know more about ZenFresh.";

export function getWhatsAppMessage(pathname: string): string {
  const match = CONTEXT_MESSAGES.filter((c) =>
    pathname.startsWith(c.prefix),
  ).sort((a, b) => b.prefix.length - a.prefix.length)[0];
  return match?.message ?? DEFAULT_MESSAGE;
}

// ZP-56's supplier fallback and ZP-59's general-contact tappable number both
// need a more specific greeting than the route-based CONTEXT_MESSAGES above
// (a visitor already mid-way through a compliance-heavy form, or already on
// the Contact page, benefits from a more targeted opener than the generic
// /partnerships message).
export const SUPPLIER_ENQUIRY_MESSAGE =
  "Hi, I'd like to apply to become a ZenFresh supplier. I have a few questions before I fill out the form.";
export const CONTACT_ENQUIRY_MESSAGE =
  "Hi, I have a question for the ZenFresh team.";
